import { Component, EventEmitter, Input, Output } from '@angular/core'
import { LayerGroupInfo, LayerGroupReference } from '../layer-groups.model'

@Component({
    selector: 'app-layer-group-title',
    templateUrl: './layer-group-title.component.html',
    styleUrls: ['./layer-group-title.component.scss'],
})
export class LayerGroupTitleComponent {
    @Input() groupInfo: LayerGroupInfo
    @Input() showShowAllButton = false
    @Input() showHideAllButton = false

    @Output() selectLayerGroup = new EventEmitter<LayerGroupReference>()
    @Output() showAllLayers = new EventEmitter<{ groupId: string }>()
    @Output() hideAllLayers = new EventEmitter<{ groupId: string }>()

    selectLayerGroupClicked(elementId: string): void {
        this.selectLayerGroup.emit({
            groupName: this.groupInfo.name,
            groupId: this.groupInfo.id,
            elementId,
        })
    }

    showAllLayersClicked(event: MouseEvent): void {
        event.stopPropagation()
        this.showAllLayers.emit({ groupId: this.groupInfo.id || this.groupInfo.name })
    }

    hideAllLayersClicked(event: MouseEvent): void {
        event.stopPropagation()
        this.hideAllLayers.emit({ groupId: this.groupInfo.id || this.groupInfo.name })
    }
}
